// extracted by css-extract-rspack-plugin
export default {"scaledDot":"Icon-module__scaledDot__DNY9v","alignedBaseRefDot":"Icon-module__alignedBaseRefDot__Dda0F","alignedAfterDot":"Icon-module__alignedAfterDot__vfkwc"};